<template>
    <div ref="eyCostCalculatorTool">
        <div class="row" v-if="viewData.currentPage === viewData.pages.COST_CALCULATOR_FORM">
            <div class="column">
                <h5>Kostenrechner</h5>
                <CostCalculatorForm
                    ref="costCalculatorForm"
                    @changeFormData="onCostCalculatorFormDataChange"
                    @updateValidity="onUpdateValidity"
                />
            </div>
            <div class="column" v-if="showValidateButton">
                <button class="button warning expand" @click.stop="validateForm">Eingabe prüfen</button>
            </div>
            <div class="column" v-else>
                <button :disabled="viewData.isLoading" class="button success expand" @click.stop="calculateCosts">Berechnung durchführen</button>
            </div>
        </div>
        <div class="row" v-else-if="viewData.currentPage === viewData.pages.SUCCESS_PAGE">
            <div class="column">
                <div class="panel" align="center">
                    <h4 class="ratisColoredText">
                        Ergebnis der Berechnung
                    </h4>
                    <div class="row" align="left">
                        <div class="small-6 columns">
                            <span class="label" for="costField">
                                Berechnete Kosten in €
                            </span>
                            <currency-input id="costField" v-model="calculatedCostsEuro" :readOnly="true" :options="viewData.currencyInputOptions"/>
                        </div>
                        <div class="small-6 columns">
                            <span class="label" for="costRatioField">
                                Berechnete Kostenquote in %
                            </span>
                            <input id="costRatioField" type="text" :value="formattedCostRatio" :readonly="true"/>
                        </div>
                    </div>
                    <p>
                        Im Ergebnis bedeutet das, dass eine Anmeldung zum Musterverfahren erst bei einer Quote ab
                        {{ formattedCostRatio }}% im späteren Insolvenzverfahren der EY Deutschland wirtschaftlich wäre.
                    </p>
                    <p>
                        Wenn Sie weitere (aktuelle) Informationen zum Musterverfahren wünschen, mit uns Ihre
                        Handlungsmöglichkeiten ausloten wollen oder einfach noch offene Fragen haben, nehmen Sie gleich
                        im Anschluss unter Angabe Ihres Namens, Ihrer Telefonnummer und E-Mail-Adresse Kontakt mit uns auf.
                        Kosten oder weitergehende Verpflichtungen entstehen Ihnen dadurch keine.
                    </p>
                </div>
            </div>
            <div class="columns small-6">
                <button class="button success expand" @click="resetForm">Neue Eingabe starten</button>
            </div>
            <div class="columns small-6">
                <button class="button success expand" @click="scrollToContact">Kostenlose Erstberatung anfordern</button>
            </div>
        </div>
        <div class="row" v-else-if="viewData.currentPage === viewData.pages.ERROR_PAGE">
            <div class="column">
                <div class="panel" align="center">
                    <h4 class="redColoredText">
                        Es ist ein Fehler aufgetreten
                    </h4>
                    <p>
                        Wir bitten Sie um Entschuldigung.
                        Leider ist beim Berechnen der Kosten ein Fehler aufgetreten.
                        Bitte versuchen Sie es erneut.
                        Sollten Sie auch nach einem neuerlichen Versuch immer noch Probleme haben, wenden Sie sich bitte an
                        <a href="mailto:info@ratis.de">info@ratis.de</a>.
                    </p>
                </div>
            </div>
            <div class="column">
                <button class="button success expand" @click="resetForm">Erneut versuchen</button>
            </div>
        </div>
        <div class="row" v-else-if="viewData.currentPage === viewData.pages.APP_DOWN">
            <div class="column">
                <div class="panel" align="center">
                    <h4 class="redColoredText">
                        Anwendung nicht verfügbar
                    </h4>
                    <p>
                        Die Anwendung steht aktuell leider nicht zur Verfügung. Bitte versuchen Sie es später erneut.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


import CurrencyInput from '../components/CurrencyInput';
import Calculation from '../helper/Calculation';
import CostCalculatorForm from '../components/CostCalculatorForm';
import TypeHelper from '../helper/TypeHelper';
import Config from '../constants/Config';

export default {
    name: 'FormView',
    components: {CostCalculatorForm, CurrencyInput },
    data: () => ({
        formData: {
            countDepotHolder: null,
            objectValue: null
        },
        calculatedCostsEuro: null,
        calculatedCostRatio: null,
        viewData: {
            isLoading: false,
            currentPage: 0,
            pages: {
                COST_CALCULATOR_FORM: 0,
                SUCCESS_PAGE: 1,
                ERROR_PAGE: 2
            },
            currencyInputOptions: {
                "currency": "EUR",
                "currencyDisplay": "symbol",
                "valueRange": {
                    "min": 0
                },
                "hideCurrencySymbolOnFocus": true,
                "hideGroupingSeparatorOnFocus": true,
                "hideNegligibleDecimalDigitsOnFocus": true,
                "autoDecimalDigits": false,
                "autoSign": true,
                "useGrouping": true,
                "accountingSign": false

            },
            isFormValid: false,
            contactAnchor: '#kontakt'
        }
    }),
    computed: {
        showValidateButton()
        {
            return this.viewData.isFormValid === false;
        },
        formattedCostRatio()
        {
            if (TypeHelper.isNotNullOrUndefined(this.calculatedCostRatio))
                return this.calculatedCostRatio.toString().replace('.', ',');

            return null;
        }
    },
    methods: {
        validateForm()
        {
            this.$refs.costCalculatorForm.validateForm();
        },
        calculateCosts()
        {
            this.viewData.isLoading = true;

            try
            {
                this.calculatedCostsEuro = Calculation.calculateCosts(this.formData.countDepotHolder, this.formData.objectValue);
                this.calculatedCostRatio = Calculation.calculateCostRatio(this.calculatedCostsEuro, this.formData.objectValue);

                this.viewData.currentPage = this.viewData.pages.SUCCESS_PAGE;

                this.createTrackingIframe();
            }
            catch (error)
            {
                this.viewData.currentPage = this.viewData.pages.ERROR_PAGE;
            }
            finally
            {
                this.viewData.isLoading = false;
                this.$refs.eyCostCalculatorTool.scrollIntoView(true);
            }
        },
        onCostCalculatorFormDataChange(newFormData)
        {
            let me = this;
            Object.keys(newFormData).forEach(property => {
                me.formData[property] = newFormData[property];
            });
        },
        onUpdateValidity(newValidity)
        {
            this.viewData.isFormValid = newValidity;
        },
        async resetForm()
        {
            this.viewData.currentPage = this.viewData.pages.COST_CALCULATOR_FORM;
            this.formData = {
                countDepotHolder: null,
                objectValue: null
            };
            this.viewData.isFormValid = false;
            this.calculatedCostRatio = null;
            this.calculatedCostsEuro = null;

            this.$refs.eyCostCalculatorTool.scrollIntoView(true);
        },
        createTrackingIframe()
        {
            let iframe = document.createElement('iframe');
            iframe.setAttribute('id', 'trackingIframe');
            iframe.setAttribute('src', Config.TRACKING_URL);
            iframe.style.display = "none";
            document.body.appendChild(iframe);
            let me = this;
            iframe.onload = () => me.removeTrackingIframe();
        },
        removeTrackingIframe()
        {
            let iframe = document.getElementById('trackingIframe');
            document.body.removeChild(iframe);
        },
        scrollToContact()
        {
            location.href = this.viewData.contactAnchor;
        }
    }
};
</script>

<style scoped>
    .ratisColoredText{
        color:#e10065;
    }
    .redColoredText{
        color: red;
    }
</style>
